module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"file-upload\"> <div class=\"row form-group\"> <div class=\"col-md-6 xs-vertical-margin sm-vertical-margin\"> <div class=\"btn btn-file-container btn-sm btn-blue btn-block\"> <span>Upload Image</span> <input type=\"file\" class=\"read-image btn-file\" accept=\"image/*\"> </div> </div> <div class=\"col-md-6 xs-vertical-margin sm-vertical-margin\"> <button class=\"btn btn-sm btn-red btn-block remove-image\">Reset Image</button> </div> </div> ")
    ;  if (locals.filename) { 
    ; __append(" <div class=\"text-center text-muted small\">")
    ; __append(escapeFn( locals.filename ))
    ; __append("</div> ")
    ;  } 
    ; __append(" <div class=\"row\"> ")
    ;  if (locals.image) { 
    ; __append(" <figure class=\"col-xs-12\"><img src=\"")
    ; __append(escapeFn( locals.image ))
    ; __append("\" alt=\"Logo\" class=\"img-responsive center-block\"></figure> ")
    ;  } else { 
    ; __append(" <figure class=\"col-xs-6 col-xs-offset-3\"><img src=\"/assets/images/icons/no-image.svg\" alt=\"Logo\" class=\"img-responsive center-block\"></figure> ")
    ;  } 
    ; __append(" </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/image_upload.ejs
// module id = 890
// module chunks = 1